module.exports = __webpack_public_path__ + "fonts/Inter-SemiBold.a2c4e882.ttf";